import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container lg:px-8 xl:px-8 2xl:px-0"
}
const _hoisted_2 = { class: "flex justify-between py-8" }
const _hoisted_3 = { class: "flex flex-col content-between -gap-y-8" }
const _hoisted_4 = { class: "py-2 text-lg font-bold" }
const _hoisted_5 = { class: "flex -gap-x-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", { class: "hidden" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-8 h-8 cursor-pointer",
  src: "/img/syi_icon_weixin@2x.png"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-44 h-44",
  src: "/img/sy_icon_qrcode@2x.png"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.toutiao.com/c/user/token/MS4wLjABAAAAudQWo7SNq67fiKsSB6a6AWykvfobMSdXgVEGnDuF3tE/?source=list&log_from=1ff4600971f29_1675931233896",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-8 h-8",
      src: "/img/syi_icon_toutiao@2x.png"
    })
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.zhihu.com/people/sectan-ying-zhe",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-8 h-8",
      src: "/img/syi_icon_zhihu@2x.png"
    })
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://weibo.com/u/7648556721",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-8 h-8",
      src: "/img/syi_icon_weibo@2x.png"
    })
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("li", { class: "hidden" }, null, -1)
const _hoisted_13 = { class: "py-2 text-lg font-bold" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "text-sm pl-2" }
const _hoisted_16 = { class: "flex justify-center -gap-x-36 py-2" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "mb-4 text-lg font-bold" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "mb-4 text-lg font-bold" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = {
  class: "text-lg font-bold",
  href: "https://recruit.sinovatio.com",
  target: "_blank"
}
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = { class: "mb-4" }
const _hoisted_26 = { class: "py-4 flex justify-between" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-36 h-14",
  src: "/img/syi_icon_logo@2x_v2.png"
}, null, -1)
const _hoisted_28 = { class: "text-right" }
const _hoisted_29 = ["innerHTML"]

import tmpl from 'src/utils/tmpl';
import { useI18n } from 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'SinovatioFooter',
  props: {
    layout: {},
    settings: {},
    menus: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const { layout, menus, settings } = __props;

const about = menus.filter((x) => x.title === t('MainLayout.footer.about'))[0];
const invest = menus.filter(
  (x) => x.title === t('MainLayout.footer.invest')
)[0];

return (_ctx: any,_cache: any) => {
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_footer = _resolveComponent("q-footer")!

  return (_openBlock(), _createBlock(_component_q_footer, { class: "flex justify-center py-8 text-secondary z-30" }, {
    default: _withCtx(() => [
      (_ctx.layout.regions?.filter((t) => t.name === 'footer-left'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('MainLayout.footer.follow')), 1),
                  _createElementVNode("ul", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("li", null, [
                      _createVNode(_component_q_btn, {
                        padding: "0",
                        flat: "",
                        round: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _createVNode(_component_q_popup_proxy, { offset: [70, -230] }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_banner, { class: "w-44 h-44 p-0" }, {
                                avatar: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11,
                    _hoisted_12
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('MainLayout.footer.hotline')), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      class: "text-lg font-bold",
                      href: `tel:${
                  _ctx.settings[_ctx.$t('MainLayout.footer.hotline')] ??
                  _ctx.$t('MainLayout.header.phone')
                }`
                    }, _toDisplayString(_ctx.settings[_ctx.$t('MainLayout.footer.hotline')] ??
                  _ctx.$t('MainLayout.header.phone')), 9, _hoisted_14),
                    _createElementVNode("span", _hoisted_15, "(" + _toDisplayString(_ctx.settings[_ctx.$t('MainLayout.footer.time')] ??
                  _ctx.$t('MainLayout.footer.weekdays')) + ")", 1)
                  ])
                ])
              ]),
              _createElementVNode("ul", _hoisted_16, [
                (_unref(about) && _unref(about).children?.length)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('MainLayout.footer.about')), 1),
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(about).children, (child) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "mt-2",
                            key: child.id
                          }, [
                            _createVNode(_component_router_link, {
                              class: "hover:text-green-600",
                              to: _unref(tmpl)(child.url, child)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(child.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(invest) && _unref(invest).children?.length)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('MainLayout.footer.invest')), 1),
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invest).children, (child) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "mt-2",
                            key: child.id
                          }, [
                            (
                    /^https:\/\//.test(child.url) ||
                    /^http:\/\//.test(child.url)
                  )
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "hover:text-green-600",
                                  href: _unref(tmpl)(child.url, child),
                                  target: "_blank"
                                }, _toDisplayString(child.title), 9, _hoisted_21))
                              : (_openBlock(), _createBlock(_component_router_link, {
                                  key: 1,
                                  class: "hover:text-green-600",
                                  to: _unref(tmpl)(child.url, child)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(child.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("a", _hoisted_23, _toDisplayString(_ctx.$t('MainLayout.footer.join')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_router_link, {
                      class: "text-lg font-bold",
                      to: "/news"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('MainLayout.footer.news')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_router_link, {
                      class: "text-lg font-bold",
                      to: "/support"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('MainLayout.footer.service')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createVNode(_component_q_separator),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", null, _toDisplayString(_ctx.settings['Copyright'] ?? _ctx.$t('MainLayout.footer.copyright')), 1),
                _createElementVNode("div", {
                  innerHTML: 
              _ctx.settings[_ctx.$t('MainLayout.footer.filing')] ??
              _ctx.$t('MainLayout.footer.record')
            
                }, null, 8, _hoisted_29)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})